import { render, staticRenderFns } from "./NtagSingleTag.vue?vue&type=template&id=532ed50a&scoped=true&"
import script from "./NtagSingleTag.vue?vue&type=script&lang=ts&"
export * from "./NtagSingleTag.vue?vue&type=script&lang=ts&"
import style0 from "./NtagSingleTag.vue?vue&type=style&index=0&id=532ed50a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532ed50a",
  null
  
)

export default component.exports